import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { GroupCreateForm } from "./components/GroupCreateForm";

export function NewGroupPage() {
  return (
    <Page title="New Group">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <GroupCreateForm />
      </Container>
    </Page>
  );
}
